export default __webpack_public_path__ + "static/me-32ebbc795a0ed22066369d56f4a1d5ff.jpg";